module.exports = __webpack_public_path__ + "img/publication.43293b54.png";